import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { MultiSelect, type MultiSelectOption } from '@/components/ui/MultiSelect';
import { t } from '@/lib/i18n';
import type { EditorState } from '../roleContractEditorState';

interface Props {
  state: EditorState;
  setState: React.Dispatch<React.SetStateAction<EditorState>>;
  actorOptions: MultiSelectOption[];
}

export function InterfacesSection({ state, setState, actorOptions }: Props) {
  return (
    <Card>
      <CardHeader><CardTitle>{t('Interfaces')}</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <MultiSelect
          label={t('Reports to (actors)')}
          options={actorOptions}
          value={state.reportingTo}
          onChange={(v) => setState((s) => ({ ...s, reportingTo: v }))}
        />
        <MultiSelect
          label={t('Collaborates with (actors)')}
          options={actorOptions}
          value={state.collaboratesWith}
          onChange={(v) => setState((s) => ({ ...s, collaboratesWith: v }))}
        />
        <MultiSelect
          label={t('Escalates to (actors)')}
          options={actorOptions}
          value={state.escalatesTo}
          onChange={(v) => setState((s) => ({ ...s, escalatesTo: v }))}
        />
      </CardContent>
    </Card>
  );
}
